export const getDateWithoutTimezoneOffset = (
  date: Date,
  subtractOffset: boolean = false
) => {
  let dateTimezoneOffset = date.getTimezoneOffset();
  let msDateTimezoneOffset = dateTimezoneOffset * 60000;
  if (Math.abs(dateTimezoneOffset) > 720) {
    msDateTimezoneOffset -= 24 * 60 * 60000;
  }
  if (subtractOffset) {
    return new Date(
      date.setTime(date.getTime() - msDateTimezoneOffset + 60 * 60000)
    );
  } else {
    return new Date(
      date.setTime(date.getTime() + msDateTimezoneOffset + 60 * 60000)
    );
  }
};
